<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>待处理列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form :inline="true" :model="formFilter" class="demo-form-inline">
                <el-form-item label="项目名称">
                    <el-input v-model="formFilter.project_name" placeholder="请输入项目名称"></el-input>
                </el-form-item>
                <el-form-item label="服务人员">
                    <el-input v-model="formFilter.name" placeholder="请输入服务人员"></el-input>
                </el-form-item>
                <el-form-item label="服务状态">
                    <el-select v-model="formFilter.status" placeholder="请选择服务状态">
                        <el-option
                            v-for="(item, index) in statusList"
                            :key="index"
                            :label="item"
                            v-if="item !== ''"
                            :value="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onFilter">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="lists"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="create_time"
                        align="center"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        prop="project_name"
                        align="center"
                        label="项目名称">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        label="服务人员">
                    </el-table-column>
                    <el-table-column
                        prop="money"
                        align="center"
                        label="服务金额">
                    </el-table-column>
                    <el-table-column
                        prop="complete_time"
                        align="center"
                        label="预计完成时间">
                    </el-table-column>
                    <el-table-column
                        label="服务状态"
                        align="center">
                        <template slot-scope="scope">
                            {{statusList[scope.row.status]}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <el-button type="text" @click="goPage(`/index/project/serviceinfo?id=${scope.row.id}&sub_id=${scope.row.sub_id}`)" size="medium">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="total_page > 1">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="10"
                        :current-page="currentPage"
                        @current-change="onPageChange"
                        :page-count="total_page">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'Main',
    inject: ['goPage'],
    data () {
        return {
            formFilter: {
                status: '',
                name: '',
                project_name: ''
            },
            lists: [],
            total_page: 1,
            statusList: ['待企业确认用户服务', '', '服务进行中', '待支付服务成果', '', '审核失败，待重新确认', '', '用户异议，待重新确认', '', '待确认服务结算']
        }
    },
    computed: {
        ...mapState({
            currentPage: 'curPage',
            condition: 'formFilter'
        })
    },
    mounted () {
        if (this.condition) {
            this.formFilter = this.condition
        }
        this.getList()
    },
    methods: {
        getList (page = this.currentPage) {
            this.$http.get('/api/user/project/subtohandle', {
                params: {
                    page,
                    size: 10,
                    status: this.formFilter.status,
                    name: this.formFilter.name,
                    project_name: this.formFilter.project_name
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.lists = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        onFilter () {
            this.$store.commit('changeCondition', this.formFilter)
            this.getList(1)
        },
        onPageChange (e) {
            this.$store.commit('changePage', e)
            this.getList(e)
        },
        getDateFromRange (d) {
            let daterange = !d ? [] : d
            let date0 = !(daterange[0] === '' || !daterange[0]) ? `${daterange[0].getFullYear()}-${daterange[0].getMonth() + 1}-${daterange[0].getDate()}` : ''
            let date1 = !(daterange[1] === '' || !daterange[1]) ? `${daterange[1].getFullYear()}-${daterange[1].getMonth() + 1}-${daterange[1].getDate()}` : ''
            return [date0, date1]
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
</style>
